import { z } from 'zod';
import { FinanceStructureSchema } from './model';

export enum CreateProposalFinanceExistingOptions {
  Yes = 'yes',
  No = 'no',
}

export enum SaleType {
  Cash = 'cash',
  Financing = 'financing',
}

export enum RateTypes {
  InterestRate = 'INTEREST_RATE',
  RateFactor = 'RATE_FACTOR',
}

export enum MarkupMethods {
  MarkupDollar = 'markupDollar',
  MarkupPercentage = 'markupPercentage',
  CustomerRate = 'customerRate',
}

export enum ProgramTypes {
  Loan = 'LOAN',
  Lease = 'LEASE',
  EFA = 'EFA',
}

export enum PaymentCalculationMethods {
  Advance = 'BEGINNING_OF_PERIOD',
  Arrears = 'END_OF_PERIOD',
}

export enum MarkupType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE',
}

export enum Structures {
  None = 'none',
  Markup = 'financeProfit',
  Subsidy = 'subsidy',
}

export type FinanceFormValues = z.infer<typeof FinanceStructureSchema>;
